export default "__VITE_ASSET__DnJ8QM85__"